module.exports = __webpack_public_path__ + "static/media/spear-phishing.30cb7441.png";